import { useState } from "react";
import { validatePassword } from "../share/validation";
import { arrowLeft, unView, view } from "../assets/images/images";
import { useLocation, useNavigate } from "react-router-dom";
import { accepetJoinCompany } from "../services/api/auth.service";

const LoginNewUser = () => {
    const token: any = useLocation().pathname.split("/").pop();
    const [apiError, setApiError] = useState<string>('');
    const nav = useNavigate();
    const [showPassword, setShowPassword] = useState<{ password: boolean; confirmPassword: boolean; }>({
        password: false,
        confirmPassword: false,
    });
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [formValues, setFormValues] = useState({
        password: "",
        confirmPassword: "",
    });
    const [errors, setErrors] = useState({
        confirmPassword: '',
        password: '',
    });
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value, type } = e.target;
        if (name === 'password') {
            const passwordError = validatePassword(value);
            setErrors(prev => ({ ...prev, password: passwordError }));
        }
        if (value.trim() === '') {
            setFormValues(prev => ({ ...prev, [name]: value.trim() }));
        } else {
            setFormValues(prev => ({ ...prev, [name]: value }));
        }
        if (name === 'confirmPassword' || name === 'password') {
            const passwordValue = name === 'password' ? value : formValues.password;
            const confirmValue = name === 'confirmPassword' ? value : formValues.confirmPassword;

            if (confirmValue && passwordValue !== confirmValue) {
                setErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
            } else {
                setErrors(prev => ({ ...prev, confirmPassword: '' }));
            }
        }
    };
    const handleSubmitStepTwo = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setApiError('');
        try {
            const payload = {
                ...formValues,
                token
            };
            const response = await accepetJoinCompany(payload);
            if (response.data.success) {
                setShowSuccessPopup(true);
            } else {
                setApiError(response.data.message);
            }
        } catch (error: any) {
            setApiError(error.response?.data?.message || 'An error occurred during signup');
            console.error('Signup failed:', error);
        }
    }
    const isFormStepOne = () => {
        const { password, confirmPassword } = formValues;
        return password && confirmPassword && password === confirmPassword && validatePassword(password) === '';
    }
    return (
        <div className="py-10 space-y-10 xl:w-[550px]  mx-auto">

            <form className="w-full space-y-8" onSubmit={(e: any) => handleSubmitStepTwo(e)}>
                <div className="space-y-4">
                    <p className="text-[24px] text-main font-bold">Create Account</p>
                    <p className="text-[18px] text-main font-bold">Enter the password</p>
                </div>
                <div className="w-full space-y-2">
                    <p className="text-[18px] text-main font-bold no-select">Password</p>
                    <div className="relative">
                        <input
                            name="password"
                            value={formValues.password}
                            onChange={handleChange}
                            type={showPassword.password ? "text" : "password"}
                            className="text-[18px] placeholder:text-subtitle text-main font-bold border border-[#EBEBED] px-4 py-[14px] rounded-md outline-none focus-none bg-transparent w-full"
                        />
                        <div className="absolute top-1/2 -translate-y-1/2 right-4">
                            <img
                                src={showPassword.password ? unView : view}
                                className="w-6 aspect-square cursor-pointer"
                                onClick={() => { setShowPassword({ ...showPassword, password: !showPassword.password }) }}
                            />
                        </div>
                    </div>
                    {errors?.password.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.password}</p>}

                </div>
                <div className="w-full space-y-2">
                    <p className="text-[18px] text-main font-bold no-select">Confirm Password</p>
                    <div className="relative">
                        <input
                            name="confirmPassword"
                            value={formValues.confirmPassword}
                            onChange={handleChange}
                            type={showPassword.confirmPassword ? "text" : "password"}
                            className={`text-[18px] placeholder:text-subtitle text-main font-bold border  px-4 py-[14px]  rounded-md outline-none focus-none bg-transparent w-full ${errors?.confirmPassword.length ? "border-[#E40F03]" : "border-[#EBEBED]"} `}
                        />
                        <div className="absolute top-1/2 -translate-y-1/2 right-4">
                            <img
                                src={showPassword.confirmPassword ? unView : view}
                                className="w-6 aspect-square cursor-pointer"
                                onClick={() => { setShowPassword({ ...showPassword, confirmPassword: !showPassword.confirmPassword }) }}
                            />
                        </div>
                    </div>
                    {errors?.confirmPassword.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.confirmPassword}</p>}
                </div>
                <button disabled={!isFormStepOne()} className={`w-full h-10 text-base font-bold flex items-center justify-center rounded-md ${isFormStepOne() ? "bg-[#3ABFC3] text-main" : "bg-[#D8F2F2] text-[#C6C6C6]"}`}>
                    Sign Up
                </button>
                {apiError && (
                    <p className="text-red-500 text-sm mt-4 text-center">{apiError}</p>
                )}
            </form>
            {showSuccessPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
                        <h2 className="text-2xl font-bold text-main mb-4">Success!</h2>
                        <p className="text-main mb-6">Your account has been created successfully.</p>
                        <button
                            onClick={() => nav('/login')}
                            className="w-full bg-[#3ABFC3] text-main font-bold py-3 rounded-md"
                        >
                            Continue to Sign in
                        </button>
                    </div>
                </div>
            )}

        </div>
    )
}
export default LoginNewUser;